import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TramRegistroService } from '../../../../services/tramiteRegistro.service';
import { MessageService } from 'primeng/api';
import {ButtonColumnType, CustomTableComponent, DataColumnType, VisorComponent,
  LoadingPanelService,
  ICustomTable, SvgLoaderComponent, PaginationParams,
  Page} from 'lib-base';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { firstValueFrom, forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { TramiteActividadesComponent } from '../tramite-actividades/tramite-actividades.component';
import {InputTextModule} from "primeng/inputtext";
import {TableLazyLoadEvent} from "primeng/table";
import {IGetTramitesUsuario} from "../../../../shared/interfaces/tramite";
import {RequestGenerarFirmadoDigital} from "../../../../shared/interfaces/firma_electronica";
import {TramiteFirmasElectronicasService} from "../../../../services/tramiteFirmasElectronicas.service";
import { CdkCopyToClipboard } from "@angular/cdk/clipboard";

@Component({
  selector: 'app-tramites-por-estado',
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonModule, TramiteActividadesComponent, VisorComponent,
    CustomTableComponent, InputTextModule, CdkCopyToClipboard],
  templateUrl: './tramites-por-estado.component.html',
  styleUrl: './tramites-por-estado.component.scss'
})
export class TramitesPorEstadoComponent implements OnInit {

  @Input({alias: 'radicado', required: false})
  set radicado(value: string | null) {
    this._radicado = value;
    this.getTramites();
  }
  @Input() title !: string;


  private _radicado: string | null = null;

  page:number = 0;
  sort:string | string[] = '';
  translations: any = {};
  size: number = 7;

  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  @ViewChild(VisorComponent) visorComponent !: VisorComponent;

  constructor(private _tr: TramRegistroService, private _ms: MessageService, private _t: TranslateService,
              private _lps: LoadingPanelService, private _tfes: TramiteFirmasElectronicasService,) {
  }

  ngOnInit() {
    this.translate();
    this.getTramites();
  }

  private async translate(): Promise<void> {
    this.translations = await firstValueFrom(forkJoin({
      tramite: this._t.get('common.tramite'),
      radicado: this._t.get('common.radicado'),
      observaciones: this._t.get('common.observaciones'),
      fechaSolicitud: this._t.get('common.fecha-solicitud'),
      noHayRegistros: this._t.get('msg.no-hay-registros'),
      dependencia: this._t.get('common.dependencia'),
      tuTramite: this._t.get('components.app-estado-tramite-pub.tu-tramite'),
      estado: this._t.get('common.estado')
    }));
    this.configureColumns();
  }

  configureColumns() {
    this.customTable = {
      columns: [
        {
          field: 'expand',
          header: '',
          class:'p-button-info',
          width: '0.5rem',
          buttonType: ButtonColumnType.EXPANDED
        },
        {
          field: 'radicado',
          header: this.translations.radicado,
          sort: true,
          columnFilter: false,
          class:'font-13 ',
          style: {color:'#0077CC'},
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          dataType: DataColumnType.TEXT
        },
        {  field: 'abrir',
          header: '',
          icon: 'pi pi-file-pdf',
          class: 'button-edit p-button-outlined pt-2 pb-2',
          width: '0rem',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: IGetTramitesUsuario) => this.getRadicadoDocument(data),
        },
        {
          field: 'tipoTramite',
          header: this.translations.tramite,
          sort: true,
          class:'color-form-label font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: false,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'secDependencia',
          header: this.translations.dependencia,
          sort: true,
          class:'brand-table-tag mx-auto my-auto font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: false,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'fechaSolicitud',
          header: this.translations.fechaSolicitud,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: false,
          dataType: DataColumnType.DATE
        },   {
          field: 'tramEstado',
          header: this.translations.estado,
          sort: true,
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: false,
          dataType: DataColumnType.ESTADO_TAG
        },
      ],
      settings: {
        table: {
          rows: this.size,
          lazy: true
        }
      }
    } as ICustomTable;
  }

  lazyloadRecords(event: TableLazyLoadEvent) {
    if (event.first != undefined && event.rows) {
      const requestPage = event.first / event.rows;
      const nextPage = requestPage > 0 ? requestPage + 1 : 0;

      if (nextPage < requestPage) {
        return;
      }
      this.page = requestPage;
      if (event.sortField)
        this.sort = `${event.sortField},${this.getOrder(event.sortOrder)}`;
    }
    this.getTramites();
  }

  //#region API Calls
  getTramites() {
    const  params: PaginationParams = {
      page: this.page,
      size: this.size,
      sort: this.sort
    }
    this._tr.getTramitesUsuario(params, this._radicado).subscribe({
      next: (response) => {
        this.customTableComponent.data = response.content;
        this.customTableComponent.totalRecords = response.totalElements;
       }
    });
  }
  //#endregion

  getOrder(order: number | null | undefined): string {
    if (order == null) return '';
    return {
      1: "ASC",
      "-1": "DESC"
    }[order] ?? '';

  }

  getRadicadoDocument(data: IGetTramitesUsuario) {
    this._lps.show(true);
    this._tfes.imprimirTramiteFirmado(data.tramRegistroSol).subscribe({
      next: value => {
        this._lps.hide();
        if (value.size)
          this.visorComponent.showDialog(value);

      }, error: err => {
        this._lps.hide()
      }
    });
  }

}
